// extracted by mini-css-extract-plugin
export default {"page":"wh-z","cartModal":"xh-z","checkout":"yh-z","placeholder":"zh-z","account":"Ah-z"};